module.exports = __webpack_public_path__ + "static/media/card_hora_icon.6dc97867.svg";